import { Stack } from '@mui/material';
import * as React from 'react';
import { useMemo } from 'react';

// Components
import Breadcrumbs from 'src/components/common/Breadcrumbs';
import ButtonBack from 'src/components/common/ButtonBack';
import useLayout from 'src/hooks/useLayout';
import { NoAuthRouteKeys } from 'src/utils/constants/routes';
// import { formatUTCTime } from 'src/utils/helpers/dayjs';
// import { FORMAT_DATE_TIME } from 'src/utils/constants/config';

type TypeItem = {
  text: string;
  icon?: React.ReactNode;
  link?: string;
};

export default function BreadcrumbWithBtnBack({
  listItem,
  // updatedAt,
  showButtonBack = true,
}: {
  listItem: TypeItem[];
  updatedAt?: string;
  showButtonBack?: boolean;
}) {
  const { isEmbedded } = useLayout();
  const backUrl = useMemo(() => {
    switch (isEmbedded) {
      case true:
        return NoAuthRouteKeys.TradeData;
      default:
        return undefined;
    }
  }, [isEmbedded]);
  return (
    <Stack direction={showButtonBack ? 'row' : 'row-reverse'} alignItems="center" justifyContent={'space-between'}>
      {showButtonBack && <ButtonBack to={backUrl} />}
      {/* <Typography gap={0.5} display={'flex'} variant="body2" color={'text.secondary'}>
        The data has been updated to
        <Typography fontWeight={500} variant="body2" color={'inherit'}>
          {formatUTCTime(FORMAT_DATE_TIME.FULL_ONLY_DATE, updatedAt ?? '')}
        </Typography>
      </Typography> */}
      <Breadcrumbs listItem={listItem} />
    </Stack>
  );
}
